import React, { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import ModalShell from "../common/ModalShell";
import { buttonClasses } from "../common/tailwindClassnames";

type CancelChangesConfirmationModalProps = {
    onToggleModal: MouseEventHandler,
    onConfirm: MouseEventHandler
}

const CancelChangesConfirmationModal = ({
    onToggleModal,
    onConfirm
}: CancelChangesConfirmationModalProps) => {
    const { t } = useTranslation();
    return (
        <ModalShell
            title={t("Unsaved Changes")}
            onClose={onToggleModal}
            footer={
                <>
                    <button
                        className={buttonClasses.destructive}
                        type="button"
                        data-testid="CancelChangesConfirmationModal-discard-button"
                        onClick={onConfirm}
                    >
                        {t("Discard Changes")}
                    </button>
                    <button
                        className={buttonClasses.cancel}
                        type="button"
                        data-testid="CancelChangesConfirmationModal-continue-button"
                        onClick={onToggleModal}
                    >
                        {t("Continue Editing")}
                    </button>
                </>
            }
        >
            <p className="text-ui-text-primary-text">
                {t("There are unsaved changes. Would you like to discard the changes or continue editing?")}
            </p>
        </ModalShell>
    );
};

export default CancelChangesConfirmationModal;
